{
  "#SEND_NOTIFICATION": {
    "APP": "Nachricht senden",
    "TITLE": "Nachricht senden",
    "NEXT": "Weiter",
    "EMPFAENGER_AUSWAEHLEN": "Empfänger auswählen",
    "EMPFAENGER_AUSWAEHLEN_DESC": "Bitte wählen Sie einen oder mehrere Empfänger aus",
    "NACHRICHT_VERFASSEN": "Nachricht verfassen",
    "NACHRICHT_VERFASSEN_DESC": "Bitte Betreff und Nachricht eingeben",
    "NACHRICHT_SENDEN": "Nachricht senden"
  }
}
